import React from 'react';
import { AddressSection } from './FormComponents';

const WarehouseAddress = ({ handleBlur,formData,errorData, handleChange }) => (
  <div className="card " style={{ borderRadius: 0 }}>

    <div style={{padding: "8px 15px 3px 11px"}}>
      <AddressSection 
        prefix="warehouse" 
        formData={formData} 
        handleChange={handleChange} 
        errorData={errorData}
        handleBlur={handleBlur}

      />
    </div>
</div>
);

export default WarehouseAddress;